import { render } from "./topUp.vue?vue&type=template&id=639bef37&scoped=true"
import script from "./topUp.vue?vue&type=script&lang=js"
export * from "./topUp.vue?vue&type=script&lang=js"

import "./topUp.vue?vue&type=style&index=0&id=639bef37&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639bef37"]])

export default __exports__